import { initialState } from './initial';
import { actionTypes } from './actions';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload,
      };

    case actionTypes.SET_POINTS_DATA:
      return {
        ...state,
        points: action.payload,
      };

    case actionTypes.SUPERADMIN_BONUS_SISTEM_PROCESSING:
      return {
        ...state,
        superadminBonusSistemProcessing: action.payload,
      };

    case actionTypes.SET_SUPERADMIN_BONUS_SISTEM_DATA:
      return {
        ...state,
        superadminBonusSistem: action.payload,
        superadminBonusSistemLoaded: true,
      };

    case actionTypes.SUPERADMIN_BONUS_SISTEM_LOAD_FINISHED:
      return {
        ...state,
        superadminBonusSistemLoadFinished: action.payload,
      };

    default:
      return state;
  }
}
